<template>
  <div class="parent" :class="graphObj.type">
    <div class="label">
      <span class="text-color"> {{ graphObj.name }} </span>
      <span class="text-primary"> {{ graphObj.suffix }} </span>
    </div>
    <div class="line line-left bg-surface-300 dark:bg-surface-600"></div>
    <div class="dot" @click.stop="setDialogToggle(!dialogToggle)">
      <div
        v-if="dialogToggle || props.suffixNeeded"
        class="dot-dialog relative bg-surface-0 dark:bg-surface-900 border-surface-300 dark:border-surface-600 border"
      >
        <span>
          <CloseButton class="absolute top-1 right-1"></CloseButton>
          <label class="text-color">Suffix</label>
        </span>
        <InputText
          v-model="graphObj.suffix"
          type="text"
          style="border: 1px solid var(--p-primary-500); border-radius: 0.25rem"
          class="max-w-full text-color"
          :pt="{ root: { style: 'padding-block: 1px; padding-inline: 3px' } }"
          @keydown.enter="setDialogToggle(false)"
          @focusout="setDialogToggle(false)"
          @click.stop=""
        />
      </div>
    </div>
    <div class="line line-right bg-surface-300 dark:bg-surface-600"></div>
  </div>
</template>

<script setup>
import { defineModel, defineProps, ref, watchEffect } from "vue";
import CloseButton from "@/components/closeButton.vue";
import InputText from "primevue/inputtext";

const props = defineProps({ suffixNeeded: Boolean });
const graphObj = defineModel();

const dialogToggle = ref(false);

watchEffect(() => {
  if (props.suffixNeeded === true) {
    dialogToggle.value = true;
  }
});

function setDialogToggle(value) {
  if (props.suffixNeeded === true) {
    dialogToggle.value = true;
    return;
  }
  dialogToggle.value = value;
}
</script>

<style scoped>
.parent {
  display: grid;
  grid-template-columns: 1fr 11px 11px 1fr;
  grid-template-rows: 1fr 22px;
  justify-content: center;
  align-items: center;
  width: fit-content;
  min-width: 7rem;
  height: fit-content;
  color: black;
}

.dot {
  position: relative;
  cursor: pointer;
  grid-row-start: 2;
  grid-column-start: 2;
  grid-column-end: span 2;
  background: #e472e1;
  width: 22px;
  height: 22px;
  border-radius: 6px;
  z-index: 10;
}

.dot-dialog {
  padding: 0.5rem;
  position: absolute;
  pointer-events: auto;
  bottom: 3.3rem;
  left: calc(50% - 3rem);
  width: 6rem;
  height: 4rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 0.25rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Added elevation effect */
}

.label {
  text-align: center;
  grid-row-start: 1;
  font-size: 0.8rem;
  grid-column-start: 1;
  grid-column-end: -1;
  z-index: 20;
  padding: 0 0.5rem;
  font-weight: bolder;
}

.line {
  grid-row-start: 2;
  grid-column-start: 1;
  grid-column-end: span 2;
  height: 3px;
  opacity: 0.6;
  z-index: 0;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-content: center;
}

.line-right {
  grid-column-start: 3;
  grid-column-end: -1;
  justify-content: flex-end;
}

.Relation {
  & > .dot {
    background: #4faff8;
    border-radius: 9999px;
  }
}

.Property {
  & > .dot {
    background: #df876c;
    border-radius: 9999px;
  }
}
</style>
